/* global Core, Sys, Resources, Language */
Sys.ns("Core");

/**
 * Parses keys + texts (including error texts) from the language.xml file,
 * stores them and provides interface for other components to fetch them.
 *
 * @class Core.LanguageManager
 * @extends Sys.Observable
 */
Core.LanguageManager = {

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.LanguageManager.superclass.constructor.apply(this, arguments);

        this.texts = {};

        this.setLanguagePrefix();
        this.setupEvents();
    },

    /**
     * @inheritdoc
     * @listens notify:resources.dataStored
     */
    setupEvents: function() {
        this.on({
            "notify:resources.dataStored": this.preload
        });
    },

    /**
     * Parses the language file (XML or JSON) and stores all keys + texts.
     *
     * @private
     * @param {string} key Resource key for identifying language format (languageXML|languageJSON).
     * @fires languageLoaded_event
     * @returns {void}
     */
    preload: function(key) {
        var data;

        if (key === "languageJSON" || key === "languageXML") {
            data = Resources.readData(key);

            if (key === "languageJSON") {
                this.texts = this.loadLanguage(data);
            }
            else if (key === "languageXML") {
                this.texts = this.loadLanguageXML(data);
            }
            this.fireEvent("languageLoaded_event");
        }
    },

    /**
     * Retrieve language data from an array containing language values.
     *
     * @private
     * @param {Array<{id: string, text: string}>} data Language array containing objects.
     * @returns {Object<{id: string, text: string}>} Object containing text id's and values.
     */
    loadLanguage: function(data) {
        return data.reduce(function(acc, value) {
            var obj = {};

            obj[value.id] = value.text;

            return Sys.applyProperties(acc, obj);
        }, {});
    },

    /**
     * Store language xml into the language manager.
     *
     * @private
     * @param {Object} xml XML data.
     * @returns {Object<{id: string, text: string}>} Object containing text id's and values.
     */
    loadLanguageXML: function(xml) {
        var rootNode = Sys.utils.XMLHelper.findAll("ds", xml.documentElement),
            collection = {}, i, node, textId;

        for (i = 0; i < rootNode.length; i++) {
            node = rootNode.item(i);
            textId = Sys.utils.XMLHelper.getAttributeValue("name", node);

            collection[textId] = node.textContent;
        }

        return collection;
    },

    /**
     * Returns the text for the specified error code.
     *
     * @deprecated 8.0.0. Not in use.
     * @param {number} errorCode The error code.
     * @returns {string} The error text.
     */
    getErrorText: function(errorCode) {
        if (this.hasText(errorCode)) {
            return this.getText(errorCode);
        }

        return "[Error ID not found]";
    },

    /**
     * Tells if LanguageManager has the text string or not.
     *
     * @param {string|number} textId The text id.
     * @returns {boolean} True if found, false otherwise.
     */
    hasText: function(textId) {
        return Sys.isDefined(this.texts[textId]);
    },

    /**
     * Returns the text for the specified text id.
     *
     * @param {string|number} textId The text id.
     * @param {Array} [values] The array containing the values to be used in the text.
     * @returns {string} The text or "[<textId]> not defined]" if not found.
     */
    getText: function(textId, values) {
        var nodes,
            result = "[" + textId + " not defined]",
            translatedString;

        if (this.languagePrefix && this.hasText(this.languagePrefix + textId)) {
            translatedString = this.texts[this.languagePrefix + textId].replace("%2B", "+");
        }
        else if (this.hasText(textId)) {
            translatedString = this.texts[textId].replace("%2B", "+");
        }

        if (values && translatedString) {
            nodes = Sys.utils.getNodesByFormat(translatedString, values);

            result = nodes.reduce(function(acc, value) {
                var text = acc;

                text += value.data.toString();

                return text;
            }, "");
        }
        else if (typeof translatedString === "string") {
            result = translatedString;
        }

        if (result === "") {
            result = "[" + textId + " not translated]";
        }

        return result;
    },

    /**
     * Sets language prefix from URL param if exists.
     *
     * @private
     * @returns {void}
     */
    setLanguagePrefix: function() {
        var URLParameters = Sys.utils.queryStringToObject(window.location.search),
            prefix = URLParameters.languagePrefix;

        this.languagePrefix = Sys.isDefined(prefix) ? prefix + "__" : "";
    }
};

Core.LanguageManager = Sys.extend(Sys.Observable, Core.LanguageManager, "Core.LanguageManager");

Sys.ns("Language");

Language.Keys = {
    "accountUnavailable": "OCTaccountUnavailable",
    "additonalFreeSpinsWon": "OCTadditonalFreeSpinsWon",
    "autoplay": "OCTautoplayPanelLabel",
    "autoplay_advancedSettings": "OCTadvancedSettings",
    "autoplay_numberSpins": "OCTnumberSpins",
    "autoplay_panelStartText": "OCTautoplayPanelStartText",
    "autoplay_setting_stopAutoPlay": "OCTstopAutoPlayColon",
    "autoplay_setting_ifBalanceDecreasesBy": "OCTifBalanceDecreasesBy",
    "autoplay_setting_ifBalanceIncreasesBy": "OCTifBalanceIncreasesBy",
    "autoplay_setting_ifFBonusIsStarted": "OCTifFBonusIsStarted",
    "autoplay_setting_ifFreeSpinsIsStarted": "OCTifFreeSpinsIsStarted",
    "autoplay_setting_ifWinExeeds": "OCTifWinExeeds",
    "autoplay_setting_onAnyWin": "OCTonAnyWin",
    "autoplay_setting_ifBalanceDecreasesByInfoTouch": "OCTlossLimitInfoTouch",
    "autoplay_setting_ifBalanceDecreasesByInfo": "OCTlossLimitInfoBalance",
    "autoplay_setting_ifBalanceDecreasesByWarning": "OCTlossLimitWarningBalance",
    "autoplay_setting_ifBalanceDecreasesByWarningTouch": "betExceedCDBbalance",
    "autoplay_stopAutoPlay": "OCTstopAutoPlay",
    "autoplay_stopText": "OCTautoplayStopText",
    "autoSpins": "OCTautoSpins",
    "betColonVar": "OCTbetColonVar",
    "betInCash": "OCTbetInCash",
    "betInCoins": "OCTbetInCoins",
    "betLevel": "OCTbetlevel",
    "betSettings_uc": "OCTbetSettingsCaps",
    "bigWin": "OCTbigWin",
    "bonusAwardedTitle": "bonusAwardedTitle",
    "bonusAwardedCongrats": "bonusAwardedCongrats",
    "btn_autoplay": "OCTautoplayButton",
    "btn_casino": "OCTcasino_btn",
    "btn_checkEnd": "OCTCheckEndButton",
    "btn_close": "OCTclose_btn",
    "btn_continue": "OCTContinue",
    "btn_deposit": "OCTdeposit_btn",
    "btn_login": "OCTlogin_btn",
    "btn_maxbet": "OCTmaxbetbutton",
    "btn_no": "OCTbtnNo",
    "btn_ok": "OCTbtnOK",
    "btn_reduceBet": "OCTreduceBet_btn",
    "btn_reload": "OCTreload_btn",
    "btn_sessionTimeOut": "OCTreload_btnRev",
    "btn_yes": "OCTbtnYes",
    "btn_addValue": "addValue",
    "cash": "OCTcash",
    "cashColon": "OCTcashColon",
    "cashColonVar": "OCTcashColonVar",
    "cashWonColon": "OCTcashWonColon",
    "coinsColonVar": "OCTcoinsColonVar",
    "coinsWonColon": "OCTcoinsWonColon",
    "coinValue": "OCTcoinValue",
    "congratulations": "OCTcongratsLC",
    "congratulations_uc": "OCTcongratsUC",
    "connectionLost": "OCTconnectionLost",
    "connectionQualityPoor": "OCTconnectionQualityPoor",
    "continue": "OCTContinue",
    "continue_uc": "OCTbutton_CONTINUE",
    "continuePlaying": "OCTcontinuePlaying",
    "deposit": "OCTdeposit",
    "depositPlay": "OCTdepositPlay",
    "error": "OCTerror",
    "freeRounds_expired": "OCTfreerounds",
    "freeRoundsFinished": "OCTfreeRoundsFinished",
    "freeRoundsLeftColon": "OCTFreeRoundsLeftwithColon",
    "freeRoundsOfferUsed": "16",
    "freeRoundsVar": "OCTfreeRoundsVar",
    "freeRoundsExtraTitle": "OCTfreeRoundsExtraTitle",
    "freeRoundsExtraWon": "OCTfreeRoundsExtraWon",
    "freeRoundWidgetFirstNoWin": "freeRoundWidgetFirstNoWin",
    "freeRoundWidgetIntro": "freeRoundWidgetIntro",
    "freeRoundWidgetPlurCongratulations": "freeRoundWidgetPlurCongratulations",
    "freeRoundWidgetSingCongratulations": "freeRoundWidgetSingCongratulations",
    "freeRoundWidgetSecondNoWin": "freeRoundWidgetSecondNoWin",
    "freeSpins": "OCTfreeSpinsUC",
    "freeSpinsLeftColonVar": "OCTfreeSpinsLeftColonVar",
    "gameClientVersion": "OCTgameClientVersion",
    "gameHistory": "OCTgameHistory",
    "gameHistory_uc": "OCTgameHistoryHeadingUC",
    "gameHistoryHeading": "OCTgameHistoryHeadingUC",
    "gameRules_uc": "OCTgameRulesUC",
    "gameServerVersion": "OCTgameServerVersion",
    "gameSettingsPanelLabel": "OCTslidePanelLabel",
    "gameUnavailable": "OCTgameUnavailable",
    "haveFreeRounds": "OCThaveFreeRounds",
    "historyNotAvailable": "OCThistoryNotAvailable",
    "landscapeMode": "OCTlandscapeMode",
    "level": "OCTlevel",
    "loading": "OCTloadingText",
    "loadingDots": "OCTloading",
    "loadingTakesLonger": "OCTloadingTakesLonger",
    "lostConnectInactivity": "OCTlostConnectInactivity",
    "machinetext_bet": "OCTmachinetext_bet",
    "machinetext_coins": "OCTmachinetext_coins",
    "machinetext_coinvalue": "OCTmachinetext_coinvalue",
    "machinetext_win": "OCTmachinetext_win",
    "megaWin": "OCTmegaWin",
    "messageCaption": "OCTmessagecaption",
    "maxBet": "OCTmaxBet",
    "minBet": "OCTminBet",
    "newHistoryWindow": "OCTnewHistoryWindow",
    "outOfMoney": "OCToutOfMoney",
    "paytable_betLineWinsLeftToRightOnly": "OCTbetLineWinsLeftToRightOnly",
    "paytable_extraInfo": "OCTextraInfo",
    "paytable_highest": "OCTpaytableHighest",
    "paytable_symbolPayout": "OCTsymbolPayout",
    "paytable_uc": "OCTbutton_paytableUC",
    "paytable_voidAllPays": "OCTvoidAllPays",
    "paytable_winningBetLinesHeading": "OCTwinningBetLinesHeading",
    "playingForFun": "OCTplayingForFun",
    "youPlayingForFun": "OCTyouPlayingFun",
    "playLimit": "OCTplayLimit",
    "quickSpin": "OCTquickSpin",
    "rc_checkPlayingLost": "OCTRCheckPlayingLost",
    "rc_checkPlayingWon": "OCTRCheckPlayingWon",
    "rc_checkReminder": "OCTRCcheckReminder",
    "reduce": "OCTreduce",
    "reload": "OCTreload",
    "reset": "OCTreset",
    "restoredGameHeader": "OCTrestoredGameHeader",
    "returnToLobby": "OCTreturnToLobby",
    "roundsLeft": "OCTroundsLeft",
    "roundsUseAcctMoney": "OCTroundsUseAcctMoney",
    "sessionTimeOut": "OCTsessionTimeOut",
    "setting_gameSound": "OCTgameSound",
    "setting_gameVibration": "OCTgameVibration",
    "setting_introGame": "OCTintroGameSetting",
    "setting_introScreenGame": "OCTintroScreeGameSetting",
    "setting_isCash": "setting_isCash",
    "setting_leftHandMode": "OCTleftHandMode",
    "setting_quickSpinGame": "OCTquickSpinGameSetting",
    "setting_spaceSpin": "OCTspaceSpin",
    "skipIntro": "OCTskipIntro",
    "slowConnection": "OCTslowConnection",
    "soundSettings_uc": "OCTsoundSettingsCaps",
    "spinSettings_uc": "OCTspinSettingsCaps",
    "spinsLeftText": "OCTspinsLeftText",
    "startFreespins": "OCTstartFreeSpins",
    "stopIfFreeSpins": "OCTstopIfFreeSpins",
    "superMegaWin": "OCTsuperMegaWin",
    "totalbet": "OCTtotalbet",
    "totalWin": "OCTTotalWinwithColonVar",
    "totalWinColon": "OCTtotalWinWithColon",
    "totalWinColon_uc": "OCTtotalWinUCnoVar",
    "totalWinColonVar": "OCTtotalWinColonVar",
    "totalWinColonVar_uc": "OCTTotalWinwithColonUC",
    "varRetriggerFSNoSpan": "OCTvarRetriggerFSNoSpan",
    "win": "OCTWin",
    "winColon_uc": "OCTwinColonUC",
    "winColonVar": "OCTwinColonVar",
    "winUpTo": "OCTwinUpTo",
    "youWin": "OCTyouWinUCNoExclamation",
    "youWonCoins": "OCTyouWonCoins",
    "cookiePolicy": "cookiePolicy",
    "cookiePolicyPart2": "cookiePolicyPart2",
    "totalWinUC": "OCTTotalWinSingleUC",
    "chooseAutoplayStopConditions": "OCTchooseAutoplayStopConditions",
    "chooseAutoplayRounds": "OCTchooseAutoplayRounds",
    "balance": "OCTbalance",
    "bet": "OCTmachinetext_bet",
    "coins": "OCTmachinetext_coins",
    "gameRulesNewTab": "OCTgameRulesNewTab",
    "gameHistoryNewTab": "OCTgameHistoryNewTab",
    "gameMode": "OCTgameMode",
    "required": "OCTrequired",
    "open": "OCTopen",

    // device detection strings
    "deviceBestGameExperience": "deviceBestGameExperience",
    "deviceBrowserUpdateMust": "deviceBrowserUpdateMust",
    "deviceOptimizedFor": "deviceOptimizedFor",
    "deviceUpdateBrowser": "deviceUpdateBrowser",
    "deviceUpdateOS": "deviceUpdateOS",
    "deviceUseBrowser": "deviceUseBrowser",
    "gameOptimisedFor": "gameOptimisedFor",
    "MGcontinueYesNo": "MGcontinueYesNo",
    "MGdeviceNoSupport": "MGdeviceNoSupport",
    "MGnoOSSupport": "MGnoOSSupport",
    "optimisedForVersion": "optimisedForVersion",
    "upgradeIn": "upgradeIn"
};
